import { render, staticRenderFns } from "./ResumenProyectoAdmin.vue?vue&type=template&id=08ea05d2"
import script from "./ResumenProyectoAdmin.vue?vue&type=script&lang=js"
export * from "./ResumenProyectoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports